import { formatArrayAsStringList } from '@eigtech/function-utils'
import { startCase } from 'lodash-es'
import { z } from 'zod'

export type ZodEnumWithUserFriendlyErrorOptions<T extends readonly string[]> = {
  optionFormatter?: (option: T[number]) => string
  enumErrorPrefix?: string
  error?: z.core.$ZodErrorMap
}

export function zodEnumWithUserFriendlyError<const T extends readonly string[]>(
  values: T,
  {
    optionFormatter = startCase,
    enumErrorPrefix = 'Invalid value. Expected: ',
    error,
  }: ZodEnumWithUserFriendlyErrorOptions<T> = {}
): z.ZodEnum<z.core.util.ToEnum<T[number]>> {
  const schema: z.ZodEnum<z.core.util.ToEnum<T[number]>> = z.enum(values, {
    error: (issue) => {
      // `invalid_enum_value` was merged into `invalid_value` in zod v4
      if (issue.code === 'invalid_value') {
        const formatted = schema.options.map(optionFormatter)
        const string: string = formatArrayAsStringList(formatted, {
          type: 'disjunction',
        })

        return `${enumErrorPrefix}${string}.`
      }

      // returning `undefined` defers to the next error map / zod's default
      return error?.(issue)
    },
  })

  return schema
}
